import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiCreatePrioShareDraft } from '../../../api';

export function useCreatePrioShareDraft() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (projectExtensionId: string) => {
      return apiCreatePrioShareDraft(projectExtensionId);
    },
    onSuccess: (_data, projectExtensionId) => {
      queryClient.invalidateQueries({
        queryKey: ['prioShares', projectExtensionId],
      });
    },
  });
}
